export default [
  {
    type: 'header',
    formItems: [
      {
        label: "背景图",
        name: "imgUrl",
        stamp: 'singleImage',
        key: "params",
        help: '建议尺寸为750*280，图片大小在500k以内'
      }
    ]
  },
  {
    type: 'banner',
    formItems: [
      {
        label: "切换时间",
        name: "interval",
        type: "text",
        stamp: 'input',
        key: "params",
        help: '轮播图自动切换的间隔时间，单位：毫秒',
      },
      {
        label: "图片",
        type: "image",
        key: "data",
        stamp: 'image'
      }
    ]
  },
  {
    type: 'windows',
    formItems: [
      {
        label: "上下边距",
        name: "paddingTB",
        type: "text",
        stamp: 'slider',
        key: "style"
      },
      {
        label: "左右边距",
        name: "paddingLR",
        type: "text",
        stamp: 'slider',
        key: "style"
      },
      {
        label: "背景颜色",
        name: "backgroundColor",
        key: "style",
        type: "color",
        stamp: 'input'
      },
      {
        label: "布局",
        name: "class",
        type: "text",
        stamp: 'radio',
        key: "style",
        help: '图片比例建议一致',
        options: [
          { label: '独占一行', value: 'full' },
          { label: '堆积两列', value: 'half' },
          { label: '堆积三列', value: 'third' },
          { label: '堆积四列', value: 'quarter' },
        ],
      },
      {
        label: "图片",
        type: "image",
        key: "data",
        stamp: 'image',
      }
    ]
  },
  // {
  //   type: 'task',
  //   formItems: [
  //     {
  //       label: "功能标题",
  //       name: "taskTitle",
  //       type: "text",
  //       stamp: 'input',
  //       key: "params"
  //     },
  //     {
  //       label: "展示标题",
  //       name: "show",
  //       stamp: 'checked',
  //       key: "params"
  //     },
  //     {
  //       label: "任务组",
  //       type: "image",
  //       key: "data",
  //       stamp: 'task',
  //     }
  //   ]
  // }
]